import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import ScrollToTop from '../../components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import PartyTypesSection from './components/PartyTypesSection';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import NossosFones from '@/components/feature/NossosFones';

export default function FestaSilenciosaPage() {
  useEffect(() => {
    document.title = 'Festa Silenciosa Silent Disco Brasil | Fones LED para Eventos — STIB';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Festa Silenciosa (Silent Disco) para casamentos, formaturas, confraternizações e festivais no Brasil. Vários DJs simultâneos com fones LED coloridos. +300 festas realizadas · STIB (11) 91777-6227'
      );
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://stibpalestrasilenciosasp.com.br/festa-silenciosa');

    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://stibpalestrasilenciosasp.com.br';

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Service',
          '@id': `${siteUrl}/festa-silenciosa#service`,
          name: 'Festa Silenciosa — Silent Disco',
          alternateName: ['Silent Disco Brasil', 'Festa Silenciosa com Fones LED', 'Silent Party Brasil'],
          description:
            'Festa Silenciosa (Silent Disco) profissional para casamentos, formaturas, confraternizações corporativas e festivais em todo o Brasil. Vários DJs simultâneos com fones LED coloridos, zero poluição sonora.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'STIB — Palestra Silenciosa Brasil',
            url: siteUrl,
            telephone: '+55-11-91777-6227',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'São Paulo',
              addressRegion: 'SP',
              addressCountry: 'BR',
            },
          },
          serviceType: 'Silent Disco — Locação de Equipamento de Áudio',
          areaServed: { '@type': 'Country', name: 'Brasil' },
          offers: {
            '@type': 'Offer',
            availability: 'https://schema.org/InStock',
            areaServed: 'BR',
            priceCurrency: 'BRL',
          },
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Serviços', item: `${siteUrl}/servicos` },
            { '@type': 'ListItem', position: 3, name: 'Festa Silenciosa', item: `${siteUrl}/festa-silenciosa` },
          ],
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Qual o número mínimo e máximo de fones para uma festa silenciosa?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Atendemos eventos a partir de 20 convidados. O teto atual é de 1.500 fones simultâneos.',
              },
            },
            {
              '@type': 'Question',
              name: 'Quantos DJs podem tocar ao mesmo tempo na silent disco?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Vários DJs simultâneos, cada um transmitindo em um canal independente. LEDs coloridos (vermelho, verde e azul) identificam visualmente cada canal.',
              },
            },
            {
              '@type': 'Question',
              name: 'A STIB atende fora de São Paulo?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Sim. Atendemos todo o Brasil — São Paulo, Rio de Janeiro, Brasília, Belo Horizonte, Curitiba, Porto Alegre, Recife, Fortaleza, Salvador e demais cidades.',
              },
            },
          ],
        },
      ],
    };

    const existing = document.getElementById('festa-silenciosa-schema');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'festa-silenciosa-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('festa-silenciosa-schema');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingCTA />
      <ScrollToTop />
      <main>
        <HeroSection />
        <WhatIsSection />
        <PartyTypesSection />
        <HowItWorksSection />
        <BenefitsSection />
        <TestimonialsSection />
        <FAQSection />
        <NossosFones />
      </main>
      <Footer />
    </div>
  );
}